import { useContext } from 'react';
import { Context } from './Context';
export function useEditorDraft() {
    const context = useContext(Context);
    if (!context) {
        throw new Error('useEditorDraft must be used within a EditorDraftProvider');
    }
    return context;
}
